export default __webpack_public_path__ + "static/media/Dillon.ef16cdc4.jpg";